import { render } from "./ScheduleCardByPlace.vue?vue&type=template&id=667f2ad0&scoped=true&ts=true"
import script from "./ScheduleCardByPlace.vue?vue&type=script&lang=ts"
export * from "./ScheduleCardByPlace.vue?vue&type=script&lang=ts"

import "./ScheduleCardByPlace.vue?vue&type=style&index=0&id=667f2ad0&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667f2ad0"]])

export default __exports__